/**
 * Подписи к значениям перечислений — один источник на интерфейс.
 *
 * ── Зачем ───────────────────────────────────────────────────────────────────
 *
 * Состояние подключения выводилось в трёх местах и тремя способами: в карточке
 * чата — по-русски, в панели аккаунтов и в списке подключений — сырым
 * `CONNECTED` капслоком латиницей. Посреди русского интерфейса это читается
 * как отладочный вывод, и главное — не отличается видом от неисправного
 * состояния: `DISCONNECTED` выглядит ровно так же солидно.
 *
 * Держать таблицу подписей рядом с одним из трёх мест бессмысленно: следующая
 * копия появляется в тот момент, когда про первую забыли.
 */

/** Состояние подключения Telegram-аккаунта. */
export const CONNECTION_LABELS: Record<string, string> = {
  CONNECTED: "На связи",
  CONNECTING: "Подключается",
  DISCONNECTED: "Отключён",
  UNAUTHORIZED: "Требуется вход",
  ERROR: "Ошибка",
};

/**
 * Подпись состояния. Неизвестное значение возвращается как есть.
 *
 * Врать «На связи» о состоянии, которого мы не знаем, хуже, чем показать
 * сырую строку: во втором случае видно, что версия интерфейса отстала.
 */
export function connectionLabel(state: string): string {
  return CONNECTION_LABELS[state] ?? state;
}

/**
 * Цветовой тон состояния.
 *
 * Только два: «работает» и «не работает». Промежуточные состояния
 * (подключается, требуется вход) намеренно попадают во второй — с точки
 * зрения менеджера аккаунт, который сейчас не отправит сообщение, неисправен,
 * и различать оттенки неисправности ему незачем.
 */
export function connectionTone(state: string): "ok" | "idle" {
  return state === "CONNECTED" ? "ok" : "idle";
}

/** Статус сотрудника. */
export const USER_STATUS_LABELS: Record<string, string> = {
  ACTIVE: "Активен",
  SUSPENDED: "Приостановлен",
  DEACTIVATED: "Отключён",
};
